export default {
  isShowLoading: false,
  isShowSnackbar: false,
  snackbarType: null,
  snackbarMessage: "",
  queryParams: null,
  isErrorInGetData: false,
  configInquiryRegister: {
    isOpen: false,
    imamHussainZiarat: false,
    hazratMassomehZiarat: false,
  },
};
